export const SelectCompanyPrompt: React.FC = () => {
    return (
        <div className="select-company-prompt">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="4" y="2" width="16" height="20" rx="2" ry="2" />
                <line x1="9" y1="6" x2="9" y2="6.01" />
                <line x1="15" y1="6" x2="15" y2="6.01" />
                <line x1="9" y1="10" x2="9" y2="10.01" />
                <line x1="15" y1="10" x2="15" y2="10.01" />
                <line x1="9" y1="14" x2="9" y2="14.01" />
                <line x1="15" y1="14" x2="15" y2="14.01" />
                <path d="M10 22v-4h4v4" />
            </svg>
            <h2>Select a company to get started</h2>
            <p>Use the company dropdown in the navigation bar above to choose which company you want to work on.</p>
        </div>
    )
}
